<div class="fullscreen-gallery" *ngIf="items?.length">
  <swiper-gallery [items]="items" [start]="position"></swiper-gallery>
  <div (click)="close()" class="swiper-close">
    <ico ico="close_24" color="var(--prime)"></ico>
  </div>
</div>

